/** Soft scattered playing-card wallpaper for the site footer */
const CARDS = [
  { x: "4%", y: "18%", rotate: -18, scale: 0.9, rank: "A", suit: "♠", color: "#111" },
  { x: "14%", y: "62%", rotate: 12, scale: 0.7, rank: "7", suit: "♥", color: "#c81e1e" },
  { x: "22%", y: "28%", rotate: 8, scale: 1.05, rank: "K", suit: "♦", color: "#c81e1e" },
  { x: "31%", y: "70%", rotate: -10, scale: 0.65, rank: "2", suit: "♣", color: "#111" },
  { x: "41%", y: "22%", rotate: 16, scale: 0.8, rank: "Q", suit: "♠", color: "#111" },
  { x: "48%", y: "58%", rotate: -22, scale: 1.1, rank: "J", suit: "♥", color: "#c81e1e" },
  { x: "58%", y: "34%", rotate: 6, scale: 0.75, rank: "9", suit: "♣", color: "#111" },
  { x: "66%", y: "68%", rotate: -14, scale: 0.95, rank: "10", suit: "♦", color: "#c81e1e" },
  { x: "74%", y: "24%", rotate: 20, scale: 0.68, rank: "3", suit: "♠", color: "#111" },
  { x: "82%", y: "55%", rotate: -8, scale: 1, rank: "A", suit: "♥", color: "#c81e1e" },
  { x: "90%", y: "30%", rotate: 11, scale: 0.72, rank: "5", suit: "♣", color: "#111" },
  { x: "8%", y: "44%", rotate: -4, scale: 0.55, rank: "8", suit: "♦", color: "#c81e1e" },
  { x: "36%", y: "46%", rotate: 24, scale: 0.58, rank: "4", suit: "♠", color: "#111" },
  { x: "70%", y: "48%", rotate: -26, scale: 0.6, rank: "6", suit: "♥", color: "#c81e1e" },
  { x: "94%", y: "72%", rotate: 15, scale: 0.85, rank: "K", suit: "♣", color: "#111" },
];

const CHIPS = [
  { x: "18%", y: "40%", size: 34, tone: "#6729fe" },
  { x: "52%", y: "78%", size: 26, tone: "#8b5cff" },
  { x: "78%", y: "42%", size: 30, tone: "#4c1db8" },
  { x: "28%", y: "82%", size: 22, tone: "#6729fe" },
  { x: "88%", y: "80%", size: 28, tone: "#8b5cff" },
];

const MiniCard = ({ rank, suit, color, style }) => (
  <div className="footer-bg-card" style={style} aria-hidden="true">
    <span className="footer-bg-card__rank" style={{ color }}>
      {rank}
    </span>
    <span className="footer-bg-card__suit" style={{ color }}>
      {suit}
    </span>
    <span className="footer-bg-card__suit footer-bg-card__suit--br" style={{ color }}>
      {suit}
    </span>
  </div>
);

const FooterBgPattern = () => (
  <div className="footer-bg-pattern" aria-hidden="true">
    {CARDS.map((card, index) => (
      <MiniCard
        key={`${card.rank}-${card.suit}-${index}`}
        rank={card.rank}
        suit={card.suit}
        color={card.color}
        style={{
          left: card.x,
          top: card.y,
          transform: `translate(-50%, -50%) rotate(${card.rotate}deg) scale(${card.scale})`,
          animationDelay: `${(index % 7) * 0.35}s`,
        }}
      />
    ))}
    {CHIPS.map((chip, index) => (
      <span
        key={`chip-${index}`}
        className="footer-bg-chip"
        style={{
          left: chip.x,
          top: chip.y,
          width: chip.size,
          height: chip.size,
          borderColor: chip.tone,
          color: chip.tone,
          animationDelay: `${(index % 5) * 0.45}s`,
        }}
      >
        $
      </span>
    ))}
  </div>
);

export default FooterBgPattern;
